import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from '@nuxt/ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _33019bd8 = () => interopDefault(import('../pages/2fa.vue' /* webpackChunkName: "pages/2fa" */))
const _13d65263 = () => interopDefault(import('../pages/abonnementen.vue' /* webpackChunkName: "pages/abonnementen" */))
const _5a732937 = () => interopDefault(import('../pages/activiteiten/index.vue' /* webpackChunkName: "pages/activiteiten/index" */))
const _61bbb71e = () => interopDefault(import('../pages/agenda.vue' /* webpackChunkName: "pages/agenda" */))
const _01874602 = () => interopDefault(import('../pages/begeleiders/index.vue' /* webpackChunkName: "pages/begeleiders/index" */))
const _37e314b2 = () => interopDefault(import('../pages/beheerder/index.vue' /* webpackChunkName: "pages/beheerder/index" */))
const _51e53182 = () => interopDefault(import('../pages/blogs/index.vue' /* webpackChunkName: "pages/blogs/index" */))
const _30b5be2e = () => interopDefault(import('../pages/documenten.vue' /* webpackChunkName: "pages/documenten" */))
const _44fd47da = () => interopDefault(import('../pages/facturen/index.vue' /* webpackChunkName: "pages/facturen/index" */))
const _39ae5dcc = () => interopDefault(import('../pages/forum.vue' /* webpackChunkName: "pages/forum" */))
const _952299ac = () => interopDefault(import('../pages/handleiding.vue' /* webpackChunkName: "pages/handleiding" */))
const _65ab97a8 = () => interopDefault(import('../pages/handleiding/_slug/index.vue' /* webpackChunkName: "pages/handleiding/_slug/index" */))
const _0d6716ed = () => interopDefault(import('../pages/leerlingen/index.vue' /* webpackChunkName: "pages/leerlingen/index" */))
const _58f85c14 = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _2f21cb8f = () => interopDefault(import('../pages/mijn-profiel.vue' /* webpackChunkName: "pages/mijn-profiel" */))
const _3361f1da = () => interopDefault(import('../pages/oefeningen/index.vue' /* webpackChunkName: "pages/oefeningen/index" */))
const _49cf0024 = () => interopDefault(import('../pages/opdrachten/index.vue' /* webpackChunkName: "pages/opdrachten/index" */))
const _1da68a0c = () => interopDefault(import('../pages/overige-informatie/index.vue' /* webpackChunkName: "pages/overige-informatie/index" */))
const _f522fcec = () => interopDefault(import('../pages/praktijk/index.vue' /* webpackChunkName: "pages/praktijk/index" */))
const _40c001d3 = () => interopDefault(import('../pages/sessies/index.vue' /* webpackChunkName: "pages/sessies/index" */))
const _71dee45a = () => interopDefault(import('../pages/wachtwoord-vergeten/index.vue' /* webpackChunkName: "pages/wachtwoord-vergeten/index" */))
const _4765b45d = () => interopDefault(import('../pages/activiteiten/aanmaken.vue' /* webpackChunkName: "pages/activiteiten/aanmaken" */))
const _5fc3b04f = () => interopDefault(import('../pages/begeleider/geen-toegang.vue' /* webpackChunkName: "pages/begeleider/geen-toegang" */))
const _1b93287b = () => interopDefault(import('../pages/begeleiders/toevoegen.vue' /* webpackChunkName: "pages/begeleiders/toevoegen" */))
const _379c3ba2 = () => interopDefault(import('../pages/beheerder/activiteiten/index.vue' /* webpackChunkName: "pages/beheerder/activiteiten/index" */))
const _f0113198 = () => interopDefault(import('../pages/beheerder/blogs/index.vue' /* webpackChunkName: "pages/beheerder/blogs/index" */))
const _18637076 = () => interopDefault(import('../pages/beheerder/facturen/index.vue' /* webpackChunkName: "pages/beheerder/facturen/index" */))
const _30173870 = () => interopDefault(import('../pages/beheerder/gebruikers/index.vue' /* webpackChunkName: "pages/beheerder/gebruikers/index" */))
const _40d33b69 = () => interopDefault(import('../pages/leerlingen/toevoegen.vue' /* webpackChunkName: "pages/leerlingen/toevoegen" */))
const _f099b860 = () => interopDefault(import('../pages/opdrachten/archief.vue' /* webpackChunkName: "pages/opdrachten/archief" */))
const _7c43de14 = () => interopDefault(import('../pages/overige-informatie/toevoegen.vue' /* webpackChunkName: "pages/overige-informatie/toevoegen" */))
const _d5a57d94 = () => interopDefault(import('../pages/praktijk/abonnementen.vue' /* webpackChunkName: "pages/praktijk/abonnementen" */))
const _67586426 = () => interopDefault(import('../pages/praktijk/facturen/index.vue' /* webpackChunkName: "pages/praktijk/facturen/index" */))
const _564cad3e = () => interopDefault(import('../pages/praktijk/opdrachten.vue' /* webpackChunkName: "pages/praktijk/opdrachten" */))
const _5709d0e0 = () => interopDefault(import('../pages/praktijk/begeleiders/leerling-dossier.vue' /* webpackChunkName: "pages/praktijk/begeleiders/leerling-dossier" */))
const _35e59a5a = () => interopDefault(import('../pages/beheerder/activiteiten/_slug.vue' /* webpackChunkName: "pages/beheerder/activiteiten/_slug" */))
const _f37e7428 = () => interopDefault(import('../pages/beheerder/blogs/_slug.vue' /* webpackChunkName: "pages/beheerder/blogs/_slug" */))
const _2e609728 = () => interopDefault(import('../pages/beheerder/gebruikers/_slug.vue' /* webpackChunkName: "pages/beheerder/gebruikers/_slug" */))
const _6ac5a6b6 = () => interopDefault(import('../pages/praktijk/facturen/_slug.vue' /* webpackChunkName: "pages/praktijk/facturen/_slug" */))
const _58bc87ef = () => interopDefault(import('../pages/activiteiten/_slug.vue' /* webpackChunkName: "pages/activiteiten/_slug" */))
const _04f48892 = () => interopDefault(import('../pages/begeleiders/_slug.vue' /* webpackChunkName: "pages/begeleiders/_slug" */))
const _55527412 = () => interopDefault(import('../pages/blogs/_slug.vue' /* webpackChunkName: "pages/blogs/_slug" */))
const _4346a692 = () => interopDefault(import('../pages/facturen/_slug.vue' /* webpackChunkName: "pages/facturen/_slug" */))
const _26152730 = () => interopDefault(import('../pages/leerlingen/_slug/index.vue' /* webpackChunkName: "pages/leerlingen/_slug/index" */))
const _31ab5092 = () => interopDefault(import('../pages/oefeningen/_slug.vue' /* webpackChunkName: "pages/oefeningen/_slug" */))
const _d5cb5eae = () => interopDefault(import('../pages/opdrachten/_slug/index.vue' /* webpackChunkName: "pages/opdrachten/_slug/index" */))
const _2113cc9c = () => interopDefault(import('../pages/overige-informatie/_slug.vue' /* webpackChunkName: "pages/overige-informatie/_slug" */))
const _f8903f7c = () => interopDefault(import('../pages/praktijk/_slug.vue' /* webpackChunkName: "pages/praktijk/_slug" */))
const _3f09608b = () => interopDefault(import('../pages/sessies/_slug.vue' /* webpackChunkName: "pages/sessies/_slug" */))
const _6efb2775 = () => interopDefault(import('../pages/wachtwoord-instellen/_token.vue' /* webpackChunkName: "pages/wachtwoord-instellen/_token" */))
const _be6e776e = () => interopDefault(import('../pages/wachtwoord-vergeten/_token.vue' /* webpackChunkName: "pages/wachtwoord-vergeten/_token" */))
const _3c4e7666 = () => interopDefault(import('../pages/leerlingen/_slug/bewerken.vue' /* webpackChunkName: "pages/leerlingen/_slug/bewerken" */))
const _7dca17d5 = () => interopDefault(import('../pages/leerlingen/_slug/informatie/index.vue' /* webpackChunkName: "pages/leerlingen/_slug/informatie/index" */))
const _15caeaa1 = () => interopDefault(import('../pages/leerlingen/_slug/sessieverslag-schrijven.vue' /* webpackChunkName: "pages/leerlingen/_slug/sessieverslag-schrijven" */))
const _eaf1a9ea = () => interopDefault(import('../pages/leerlingen/_slug/aantekeningen/toevoegen.vue' /* webpackChunkName: "pages/leerlingen/_slug/aantekeningen/toevoegen" */))
const _6f0e7c92 = () => interopDefault(import('../pages/leerlingen/_slug/aantekeningen/_id.vue' /* webpackChunkName: "pages/leerlingen/_slug/aantekeningen/_id" */))
const _aa7640cc = () => interopDefault(import('../pages/leerlingen/_slug/informatie/_aanvulling/index.vue' /* webpackChunkName: "pages/leerlingen/_slug/informatie/_aanvulling/index" */))
const _434c45fe = () => interopDefault(import('../pages/leerlingen/_slug/sessieverslagen/_verslag_id/index.vue' /* webpackChunkName: "pages/leerlingen/_slug/sessieverslagen/_verslag_id/index" */))
const _63d12a10 = () => interopDefault(import('../pages/leerlingen/_slug/informatie/_aanvulling/aanpassen.vue' /* webpackChunkName: "pages/leerlingen/_slug/informatie/_aanvulling/aanpassen" */))
const _03b6be74 = () => interopDefault(import('../pages/leerlingen/_slug/sessieverslagen/_verslag_id/aanpassen.vue' /* webpackChunkName: "pages/leerlingen/_slug/sessieverslagen/_verslag_id/aanpassen" */))
const _10a13212 = () => interopDefault(import('../pages/opdrachten/_slug/_leerling.vue' /* webpackChunkName: "pages/opdrachten/_slug/_leerling" */))
const _e15e8e06 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/2fa",
    component: _33019bd8,
    name: "2fa"
  }, {
    path: "/abonnementen",
    component: _13d65263,
    name: "abonnementen"
  }, {
    path: "/activiteiten",
    component: _5a732937,
    name: "activiteiten"
  }, {
    path: "/agenda",
    component: _61bbb71e,
    name: "agenda"
  }, {
    path: "/begeleiders",
    component: _01874602,
    name: "begeleiders"
  }, {
    path: "/beheerder",
    component: _37e314b2,
    name: "beheerder"
  }, {
    path: "/blogs",
    component: _51e53182,
    name: "blogs"
  }, {
    path: "/documenten",
    component: _30b5be2e,
    name: "documenten"
  }, {
    path: "/facturen",
    component: _44fd47da,
    name: "facturen"
  }, {
    path: "/forum",
    component: _39ae5dcc,
    name: "forum"
  }, {
    path: "/handleiding",
    component: _952299ac,
    name: "handleiding",
    children: [{
      path: ":slug",
      component: _65ab97a8,
      name: "handleiding-slug"
    }]
  }, {
    path: "/leerlingen",
    component: _0d6716ed,
    name: "leerlingen"
  }, {
    path: "/login",
    component: _58f85c14,
    name: "login"
  }, {
    path: "/mijn-profiel",
    component: _2f21cb8f,
    name: "mijn-profiel"
  }, {
    path: "/oefeningen",
    component: _3361f1da,
    name: "oefeningen"
  }, {
    path: "/opdrachten",
    component: _49cf0024,
    name: "opdrachten"
  }, {
    path: "/overige-informatie",
    component: _1da68a0c,
    name: "overige-informatie"
  }, {
    path: "/praktijk",
    component: _f522fcec,
    name: "praktijk"
  }, {
    path: "/sessies",
    component: _40c001d3,
    name: "sessies"
  }, {
    path: "/wachtwoord-vergeten",
    component: _71dee45a,
    name: "wachtwoord-vergeten"
  }, {
    path: "/activiteiten/aanmaken",
    component: _4765b45d,
    name: "activiteiten-aanmaken"
  }, {
    path: "/begeleider/geen-toegang",
    component: _5fc3b04f,
    name: "begeleider-geen-toegang"
  }, {
    path: "/begeleiders/toevoegen",
    component: _1b93287b,
    name: "begeleiders-toevoegen"
  }, {
    path: "/beheerder/activiteiten",
    component: _379c3ba2,
    name: "beheerder-activiteiten"
  }, {
    path: "/beheerder/blogs",
    component: _f0113198,
    name: "beheerder-blogs"
  }, {
    path: "/beheerder/facturen",
    component: _18637076,
    name: "beheerder-facturen"
  }, {
    path: "/beheerder/gebruikers",
    component: _30173870,
    name: "beheerder-gebruikers"
  }, {
    path: "/leerlingen/toevoegen",
    component: _40d33b69,
    name: "leerlingen-toevoegen"
  }, {
    path: "/opdrachten/archief",
    component: _f099b860,
    name: "opdrachten-archief"
  }, {
    path: "/overige-informatie/toevoegen",
    component: _7c43de14,
    name: "overige-informatie-toevoegen"
  }, {
    path: "/praktijk/abonnementen",
    component: _d5a57d94,
    name: "praktijk-abonnementen"
  }, {
    path: "/praktijk/facturen",
    component: _67586426,
    name: "praktijk-facturen"
  }, {
    path: "/praktijk/opdrachten",
    component: _564cad3e,
    name: "praktijk-opdrachten"
  }, {
    path: "/praktijk/begeleiders/leerling-dossier",
    component: _5709d0e0,
    name: "praktijk-begeleiders-leerling-dossier"
  }, {
    path: "/beheerder/activiteiten/:slug",
    component: _35e59a5a,
    name: "beheerder-activiteiten-slug"
  }, {
    path: "/beheerder/blogs/:slug",
    component: _f37e7428,
    name: "beheerder-blogs-slug"
  }, {
    path: "/beheerder/gebruikers/:slug",
    component: _2e609728,
    name: "beheerder-gebruikers-slug"
  }, {
    path: "/praktijk/facturen/:slug",
    component: _6ac5a6b6,
    name: "praktijk-facturen-slug"
  }, {
    path: "/activiteiten/:slug",
    component: _58bc87ef,
    name: "activiteiten-slug"
  }, {
    path: "/begeleiders/:slug",
    component: _04f48892,
    name: "begeleiders-slug"
  }, {
    path: "/blogs/:slug",
    component: _55527412,
    name: "blogs-slug"
  }, {
    path: "/facturen/:slug",
    component: _4346a692,
    name: "facturen-slug"
  }, {
    path: "/leerlingen/:slug",
    component: _26152730,
    name: "leerlingen-slug"
  }, {
    path: "/oefeningen/:slug",
    component: _31ab5092,
    name: "oefeningen-slug"
  }, {
    path: "/opdrachten/:slug",
    component: _d5cb5eae,
    name: "opdrachten-slug"
  }, {
    path: "/overige-informatie/:slug?",
    component: _2113cc9c,
    name: "overige-informatie-slug"
  }, {
    path: "/praktijk/:slug",
    component: _f8903f7c,
    name: "praktijk-slug"
  }, {
    path: "/sessies/:slug",
    component: _3f09608b,
    name: "sessies-slug"
  }, {
    path: "/wachtwoord-instellen/:token?",
    component: _6efb2775,
    name: "wachtwoord-instellen-token"
  }, {
    path: "/wachtwoord-vergeten/:token?",
    component: _be6e776e,
    name: "wachtwoord-vergeten-token"
  }, {
    path: "/leerlingen/:slug/bewerken",
    component: _3c4e7666,
    name: "leerlingen-slug-bewerken"
  }, {
    path: "/leerlingen/:slug/informatie",
    component: _7dca17d5,
    name: "leerlingen-slug-informatie"
  }, {
    path: "/leerlingen/:slug/sessieverslag-schrijven",
    component: _15caeaa1,
    name: "leerlingen-slug-sessieverslag-schrijven"
  }, {
    path: "/leerlingen/:slug/aantekeningen/toevoegen",
    component: _eaf1a9ea,
    name: "leerlingen-slug-aantekeningen-toevoegen"
  }, {
    path: "/leerlingen/:slug/aantekeningen/:id?",
    component: _6f0e7c92,
    name: "leerlingen-slug-aantekeningen-id"
  }, {
    path: "/leerlingen/:slug/informatie/:aanvulling",
    component: _aa7640cc,
    name: "leerlingen-slug-informatie-aanvulling"
  }, {
    path: "/leerlingen/:slug/sessieverslagen/:verslag_id",
    component: _434c45fe,
    name: "leerlingen-slug-sessieverslagen-verslag_id"
  }, {
    path: "/leerlingen/:slug/informatie/:aanvulling/aanpassen",
    component: _63d12a10,
    name: "leerlingen-slug-informatie-aanvulling-aanpassen"
  }, {
    path: "/leerlingen/:slug/sessieverslagen/:verslag_id?/aanpassen",
    component: _03b6be74,
    name: "leerlingen-slug-sessieverslagen-verslag_id-aanpassen"
  }, {
    path: "/opdrachten/:slug/:leerling",
    component: _10a13212,
    name: "opdrachten-slug-leerling"
  }, {
    path: "/",
    component: _e15e8e06,
    name: "index"
  }],

  fallback: false
}

function decodeObj(obj) {
  for (const key in obj) {
    if (typeof obj[key] === 'string') {
      obj[key] = decode(obj[key])
    }
  }
}

export function createRouter () {
  const router = new Router(routerOptions)

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    const r = resolve(to, current, append)
    if (r && r.resolved && r.resolved.query) {
      decodeObj(r.resolved.query)
    }
    return r
  }

  return router
}
